import React, { useEffect, useState, useContext } from "react";
import { Table, Modal, Button, notification, DatePicker } from "antd";
import { Calendar, Edit, Trash2, ArrowLeft } from "lucide-react";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import {
  getSingleLeaveEmployee,
  deleteLeaveEmployee,
  getUserLeaves,
  getShortLeaves,
  getDutyLeaves,
  getSpecialLeaves,
  getCoverupRequests,
  respondToCoverupRequest,
  getMyCoverupNeededLeaves,
  getMaternityLeaves,
  deleteShortLeave,
  deleteDutyLeave,
  deleteSpecialLeave,
  deleteMaternityLeave,
} from "../../service/leavesEmployeeApiService";
import { getWorkingDaysCurrentMonth, getWorkingDaysCurrentMonthByType } from "../../service/holidayService.js";
import { getEmployeeByUserId } from "../../service/employeeService";
import AddLeaveEmployee from "../../core/modals/hrm/addleaveemployee";
import EditLeaveEmployee from "../../core/modals/hrm/editleaveemployee";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";

const LeavesEmployee = () => {
  const { user } = useContext(UserContext);
  const [leaveEmployees, setLeaveEmployees] = useState([]);
  const [search] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEmployeeLeave, setSelectedEmployeeLeave] = useState(null);
  const [leaveBalances, setLeaveBalances] = useState([]);
  const [shortLeaves, setShortLeaves] = useState([]);
  const [dutyLeaves, setDutyLeaves] = useState([]);
  const [specialLeaves, setSpecialLeaves] = useState([]);
  const [maternityLeaves, setMaternityLeaves] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [coverupRequests, setCoverupRequests] = useState([]);
  const [mySentCoverupRequests, setMySentCoverupRequests] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("leaves");
  const [workingDays, setWorkingDays] = useState(null);
  const [isFemale, setIsFemale] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState("");
  const [api, contextHolder] = notification.useNotification();
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);
  const handleAddModalOk = () => setIsAddModalOpen(false);
  const handleAddModalCancel = () => setIsAddModalOpen(false);

  const showNotification = (type, message, description) => {
    api[type]({
      message,
      description,
      placement: "topRight",
      duration: 4.5,
    });
  };
  const getUserType = async () => {
    let _userType = "";
    try {
      if(userType) {
        _userType = userType;
        FetchWorkingDays(_userType);
      } else {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user?.data?._id) {
          const response = await getEmployeeByUserId(user.data._id);
          if (response.status === 200 && response.data.data) {
            _userType = response.data.data.employee_type || "";
            console.log("User Type:", _userType);
            // Fetch working days with the correct user type
            setUserType(_userType);
            FetchWorkingDays(_userType);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching user type:", error);
      _userType = "";
      FetchWorkingDays(_userType);
    }
  };
  useEffect(() => {
    getUserType();
    FetchLeaveEmployees();
    FetchUserLeaves();
    FetchShortLeaves();
    FetchDutyLeaves();
    FetchSpecialLeaves();
    FetchMaternityLeaves();
    fetchEmployeeGender();
  }, []);

  useEffect(() => {
    if (activeTab === "coverupRequests") {
      fetchCoverupData();
    }
    if (activeTab === "mySentCoverup") {
      fetchMySentCoverupData();
    }
  }, [activeTab]);

  const fetchMySentCoverupData = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.data?._id) {
        throw new Error("User not authenticated");
      }
      const response = await getMyCoverupNeededLeaves(user.data._id);
      const normalizedMySentCoverups = (response.data || []).map((request) => {
        const utcDate = new Date(request.leaveDate);
        const normalizedDate = new Date(
          Date.UTC(
            utcDate.getUTCFullYear(),
            utcDate.getUTCMonth(),
            utcDate.getUTCDate()
          )
        );
        return {
          ...request,
          startDate: normalizedDate,
          endDate: normalizedDate,
        };
      });
      setMySentCoverupRequests(normalizedMySentCoverups);
    } catch (error) {
      console.error("Error fetching sent coverup requests:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const FetchLeaveEmployees = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const leaveEmployees = await getSingleLeaveEmployee(userId);
      console.log("Raw leaveEmployees:", leaveEmployees);

      const normalizedLeaves = leaveEmployees.map((leave) => {
        if (leave.leaveDays && leave.leaveDays.length > 0) {
          return {
            ...leave,
            key: leave._id,
            startDate: leave.startDate || leave.leaveDays[0].date,
            endDate:
              leave.endDate || leave.leaveDays[leave.leaveDays.length - 1].date,
            date: leave.date || leave.appliedOn,
          };
        } else {
          const utcDate = new Date(leave.leaveDate);
          const normalizedDate = new Date(
            Date.UTC(
              utcDate.getUTCFullYear(),
              utcDate.getUTCMonth(),
              utcDate.getUTCDate()
            )
          );
          return {
            ...leave,
            key: leave._id,
            startDate: normalizedDate,
            endDate: normalizedDate,
            leaveDays: [
              {
                date: normalizedDate,
                Day: leave.attendanceType,
              },
            ],
            date: leave.appliedOn,
          };
        }
      });

      console.log("Normalized leaveEmployees:", normalizedLeaves);
      setLeaveEmployees(normalizedLeaves);
      setPagination((prev) => ({ ...prev, total: normalizedLeaves.length }));
    } catch (error) {
      console.error("Error fetching leave employees:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const FetchUserLeaves = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const response = await getUserLeaves(userId);
      console.log("Leave Balances:", response.leaveBalances);
      setLeaveBalances(response.leaveBalances);
    } catch (error) {
      console.error("Failed to fetch leave balances:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const FetchShortLeaves = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const response = await getShortLeaves(userId);
      console.log("Short Leaves:", response);
      const normalizedShortLeaves = response.map((leave) => ({
        ...leave,
        startDate: leave.startDate
          ? new Date(
              Date.UTC(
                new Date(leave.startDate).getUTCFullYear(),
                new Date(leave.startDate).getUTCMonth(),
                new Date(leave.startDate).getUTCDate()
              )
            )
          : null,
        endDate: leave.endDate
          ? new Date(
              Date.UTC(
                new Date(leave.endDate).getUTCFullYear(),
                new Date(leave.endDate).getUTCMonth(),
                new Date(leave.endDate).getUTCDate()
              )
            )
          : null,
      }));
      setShortLeaves(normalizedShortLeaves);
    } catch (error) {
      console.error("Failed to fetch short leaves:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const FetchDutyLeaves = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const response = await getDutyLeaves(userId);
      console.log("Duty Leaves:", response);
      const normalizedDutyLeaves = response.map((leave) => ({
        ...leave,
        startDate: leave.startDate
          ? new Date(
              Date.UTC(
                new Date(leave.startDate).getUTCFullYear(),
                new Date(leave.startDate).getUTCMonth(),
                new Date(leave.startDate).getUTCDate()
              )
            )
          : null,
        endDate: leave.endDate
          ? new Date(
              Date.UTC(
                new Date(leave.endDate).getUTCFullYear(),
                new Date(leave.endDate).getUTCMonth(),
                new Date(leave.endDate).getUTCDate()
              )
            )
          : null,
      }));
      setDutyLeaves(normalizedDutyLeaves);
    } catch (error) {
      console.error("Failed to fetch duty leaves:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const FetchSpecialLeaves = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const response = await getSpecialLeaves(userId);
      console.log("Special Leaves:", response);
      const normalizedSpecialLeaves = response.map((leave) => ({
        ...leave,
        startDate: leave.startDate
          ? new Date(
              Date.UTC(
                new Date(leave.startDate).getUTCFullYear(),
                new Date(leave.startDate).getUTCMonth(),
                new Date(leave.startDate).getUTCDate()
              )
            )
          : null,
        endDate: leave.endDate
          ? new Date(
              Date.UTC(
                new Date(leave.endDate).getUTCFullYear(),
                new Date(leave.endDate).getUTCMonth(),
                new Date(leave.endDate).getUTCDate()
              )
            )
          : null,
      }));
      setSpecialLeaves(normalizedSpecialLeaves);
    } catch (error) {
      console.error("Failed to fetch special leaves:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const FetchMaternityLeaves = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const response = await getMaternityLeaves(userId);
      console.log("Maternity Leaves:", response);
      const normalizedMaternityLeaves = (response.data || []).map((leave) => ({
        ...leave,
        startDate: leave.startDate
          ? new Date(
              Date.UTC(
                new Date(leave.startDate).getUTCFullYear(),
                new Date(leave.startDate).getUTCMonth(),
                new Date(leave.startDate).getUTCDate()
              )
            )
          : null,
        endDate: leave.endDate
          ? new Date(
              Date.UTC(
                new Date(leave.endDate).getUTCFullYear(),
                new Date(leave.endDate).getUTCMonth(),
                new Date(leave.endDate).getUTCDate()
              )
            )
          : null,
        expectedDeliveryDate: leave.expectedDeliveryDate
          ? new Date(
              Date.UTC(
                new Date(leave.expectedDeliveryDate).getUTCFullYear(),
                new Date(leave.expectedDeliveryDate).getUTCMonth(),
                new Date(leave.expectedDeliveryDate).getUTCDate()
              )
            )
          : null,
      }));
      setMaternityLeaves(normalizedMaternityLeaves);
    } catch (error) {
      console.error("Failed to fetch maternity leaves:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const FetchWorkingDays = async (type) => {
    try {
      const response = type ? await getWorkingDaysCurrentMonthByType(type) :  await getWorkingDaysCurrentMonth();
      console.log("Working Days:", response);
      // Normalize the working days to ensure it's not negative
      // TODO: check back-end why is workingDays sometimes negative
      setWorkingDays(response.workingDays > 0 ? response.workingDays : 0);
    } catch (error) {
      console.error("Failed to fetch working days:", error.message);
    }
  };

  const fetchEmployeeGender = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const response = await getEmployeeByUserId(userId);
      if (response.status === 200 && response.data.data) {
        setIsFemale(response.data.data.gender?.toLowerCase() === "female");
      } else {
        setIsFemale(false);
      }
    } catch (error) {
      console.error("Error fetching employee gender:", error);
      setIsFemale(false);
    }
  };

  const fetchCoverupData = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.data?._id) {
        throw new Error("User not authenticated");
      }
      const response = await getCoverupRequests(user.data._id);
      console.log("Coverup Requests:", response.data);

      const normalizedCoverupRequests = response.data.map((request) => {
        const utcDate = new Date(request.leaveDate);
        const normalizedDate = new Date(
          Date.UTC(
            utcDate.getUTCFullYear(),
            utcDate.getUTCMonth(),
            utcDate.getUTCDate()
          )
        );
        return {
          ...request,
          startDate: normalizedDate,
          endDate: normalizedDate,
        };
      });

      setCoverupRequests(normalizedCoverupRequests);
    } catch (error) {
      console.error("Error fetching coverup requests:", error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = (id) => {
    showNotification(
      "warning",
      "Are you sure?",
      <div>
        <div style={{ marginTop: "16px", display: "flex", gap: "8px" }}>
          <Button
            type="primary"
            style={{ backgroundColor: "#00ff00", borderColor: "#00ff00" }}
            onClick={async () => {
              try {
                let response;
                let leaveTypeText;

                switch (activeTab) {
                  case "leaves":
                    response = await deleteLeaveEmployee(id);
                    leaveTypeText = "Regular Leave";
                    break;
                  case "shortLeaves":
                    response = await deleteShortLeave(id);
                    leaveTypeText = "Short Leave";
                    break;
                  case "dutyLeaves":
                    response = await deleteDutyLeave(id);
                    leaveTypeText = "Duty Leave";
                    break;
                  case "specialLeaves":
                    response = await deleteSpecialLeave(id);
                    leaveTypeText = "Special Leave";
                    break;
                  case "maternityLeaves":
                    response = await deleteMaternityLeave(id);
                    leaveTypeText = "Maternity Leave";
                    break;
                  default:
                    throw new Error("Invalid leave type");
                }

                if (response) {
                  api.destroy();
                  showNotification(
                    "success",
                    "Deleted!",
                    `${leaveTypeText} has been deleted successfully.`
                  );
                  handleReload();
                }
              } catch (error) {
                console.error(`Failed to delete ${activeTab} leave:`, error);
                const errorMessage = error.response?.data?.message || error.message || `Failed to delete ${activeTab} leave.`;
                showNotification(
                  "error",
                  "Error",
                  errorMessage
                );
              }
            }}
          >
            Yes, delete it!
          </Button>
          <Button danger onClick={() => api.destroy()}>
            Cancel
          </Button>
        </div>
      </div>
    );
  };

  const handleCoverupResponse = async (
    leaveId,
    response,
    rejectionReason = ""
  ) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.data?._id) {
        throw new Error("User not authenticated");
      }
      await respondToCoverupRequest(
        leaveId,
        response,
        user.data._id,
        rejectionReason
      );
      await fetchCoverupData();
      showNotification(
        "success",
        "Success!",
        `Coverup request ${response.toLowerCase()} successfully`
      );
    } catch (error) {
      showNotification(
        "error",
        "Error!",
        error.response?.data?.message ||
          error.message ||
          "Failed to process request"
      );
    }
  };

  const handleReload = () => {
    getUserType();
    FetchUserLeaves();
    FetchLeaveEmployees();
    FetchShortLeaves();
    FetchDutyLeaves();
    FetchSpecialLeaves();
    FetchMaternityLeaves();
    fetchCoverupData();
    fetchMySentCoverupData();
    // FetchWorkingDays();
  };

  const processLeaves = (data) => {
    let processed = [...(data || [])];

    // Filter by Search
    if (search) {
      processed = processed.filter((item) => {
        const leaveTypeName = item?.leavetype?.name || "";
        return leaveTypeName.toLowerCase().includes(search.toLowerCase());
      });
    }

    // Filter by Date
    if (selectedDate) {
      const selectedDateStr = selectedDate.format("YYYY-MM-DD");
      processed = processed.filter((item) => {
        const date = item.startDate
          ? moment(item.startDate)
          : item.date
          ? moment(item.date)
          : null;
        return date && date.format("YYYY-MM-DD") === selectedDateStr;
      });
    }

    // Sort by Date (Newest First)
    processed.sort((a, b) => {
      const dateA = a.startDate
        ? new Date(a.startDate)
        : a.date
        ? new Date(a.date)
        : new Date(0);
      const dateB = b.startDate
        ? new Date(b.startDate)
        : b.date
        ? new Date(b.date)
        : new Date(0);
      return dateB - dateA;
    });

    return processed;
  };

  const filteredData = processLeaves(leaveEmployees);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const formatAttendanceLabel = (value) => {
    if (!value) return "-";
    const label = value.toString().trim().toUpperCase();
    switch (label) {
      case "FIRST HALF":
        return "First Half";
      case "SECOND HALF":
        return "Second Half";
      case "FULL DAY":
        return "Full Day";
      default:
        return value;
    }
  };

  const getLeaveDurationLabel = (record) => {
    if (!record) return "-";

    const labelsFromDays = (record.leaveDays || [])
      .map((day) => day?.Day || day?.attendanceType || day?.dayType)
      .filter(Boolean);

    const labelsFromAttendance = Array.isArray(record.attendanceType)
      ? record.attendanceType
      : record.attendanceType
      ? [record.attendanceType]
      : [];

    const combined = [...labelsFromDays, ...labelsFromAttendance];
    if (combined.length === 0) return "-";

    const uniqueLabels = Array.from(new Set(combined.map((item) => item?.toString().trim())));
    return uniqueLabels.map((item) => formatAttendanceLabel(item)).join(", ");
  };

  const getCoverupName = (record) => {
    const coverup = record?.coverupEmployee || record?.coverupEmployeeDetails;
    if (!coverup) return "-";
    return (
      coverup.full_name ||
      `${coverup.first_name || ""} ${coverup.last_name || ""}`.trim() ||
      coverup.employee_id ||
      "-"
    );
  };

  const regularColumns = [
    {
      title: "Type",
      dataIndex: "leavetype",
      key: "type",
      width: 150,
      render: (leavetype) => leavetype?.name || "-",
    },
    {
      title: "Duration",
      dataIndex: "attendanceType",
      key: "duration",
      width: 140,
      render: (_, record) => getLeaveDurationLabel(record),
    },
    {
      title: "Start",
      dataIndex: "startDate",
      key: "startDate",
      width: 120,
      render: (startDate) =>
        startDate
          ? new Date(startDate).toLocaleDateString("en-US", { timeZone: "UTC" })
          : "-",
    },
    {
      title: "End",
      dataIndex: "endDate",
      key: "endDate",
      width: 120,
      render: (endDate) =>
        endDate
          ? new Date(endDate).toLocaleDateString("en-US", { timeZone: "UTC" })
          : "-",
    },
    {
      title: "Post",
      dataIndex: "date",
      key: "date",
      width: 120,
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },
    {
      title: "Cover-up",
      key: "coverup",
      width: 180,
      render: (_, record) => getCoverupName(record),
    },
    {
      title: "Status",
      key: "status",
      width: 200,
      render: (_, record) => {
        const renderApprovalStatus = (approval, coverupStatus) => {
          let statusElement;
          if (approval === null) {
            statusElement = (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f0ad4e",
                  borderColor: "#f0ad4e",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Pending
              </Button>
            );
          } else if (approval === true) {
            statusElement = (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#52c41a",
                  borderColor: "#52c41a",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Approved
              </Button>
            );
          } else if (approval === false) {
            statusElement = (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f5222d",
                  borderColor: "#f5222d",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Rejected
              </Button>
            );
          } else {
            statusElement = (
              <Button type="default" size="small">
                -
              </Button>
            );
          }

          let coverupElement;
          if (coverupStatus) {
            switch (coverupStatus) {
              case "PENDING":
                coverupElement = (
                  <Button
                    type="default"
                    size="small"
                    style={{
                      backgroundColor: "#f0ad4e",
                      borderColor: "#f0ad4e",
                      color: "#fff",
                      width: "90%",
                    }}
                  >
                    Coverup Pending
                  </Button>
                );
                break;
              case "ACCEPTED":
                coverupElement = (
                  <Button
                    type="default"
                    size="small"
                    style={{
                      backgroundColor: "#52c41a",
                      borderColor: "#52c41a",
                      color: "#fff",
                      width: "90%",
                    }}
                  >
                    Coverup Approved
                  </Button>
                );
                break;
              case "REJECTED":
                coverupElement = (
                  <Button
                    type="default"
                    size="small"
                    style={{
                      backgroundColor: "#f5222d",
                      borderColor: "#f5222d",
                      color: "#fff",
                      width: "90%",
                    }}
                  >
                    Coverup Rejected
                  </Button>
                );
                break;
              default:
                coverupElement = null;
            }
          }

          return (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {statusElement}
              {coverupElement}
            </div>
          );
        };
        return renderApprovalStatus(record.approval, record.coverupStatus);
      },
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) => {
        const adminStatus = record?.approval; // null=Pending, true=Approved, false=Rejected
        const coverupStatus = record?.coverupStatus; // "PENDING", "ACCEPTED", "REJECTED"

        // fix.md rules for Regular leaves:
        // Admin Approved  → Edit ❌ | Delete ❌
        // Admin Rejected  → Edit ❌ | Delete ❌
        // Admin Pending & Cover-up Pending  → Edit ✅ | Delete ✅
        // Admin Pending & Cover-up Approved → Edit ❌ | Delete ✅
        const canEdit = adminStatus === null && coverupStatus !== "ACCEPTED";
        const canDelete = adminStatus === null;

        if (!canEdit && !canDelete) return null;

        return (
          <div className="action-table-data">
            {canEdit && (
              <button
                className={`action-button edit-button ${
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                    ? ""
                    : "disabled-button"
                }`}
                onClick={() => {
                  if (
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "HRM",
                      "Leaves",
                      "edit",
                      "Employee Leaves"
                    )
                  ) {
                    setSelectedEmployeeLeave(record);
                    setIsModalOpen(true);
                  }
                }}
                title={
                  !(
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "HRM",
                      "Leaves",
                      "edit",
                      "Employee Leaves"
                    )
                  )
                    ? "You don't have permission to edit employee leaves"
                    : "Edit leave"
                }
              >
                <Edit size={18} />
              </button>
            )}
            {canDelete && (
              <button
                className={`action-button delete-button ${
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                    ? ""
                    : "disabled-button"
                }`}
                onClick={() => {
                  if (
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "HRM",
                      "Leaves",
                      "delete",
                      "Employee Leaves"
                    )
                  ) {
                    handleDelete(record._id || record.id);
                  }
                }}
                title={
                  !(
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "HRM",
                      "Leaves",
                      "delete",
                      "Employee Leaves"
                    )
                  )
                    ? "You don't have permission to delete employee leaves"
                    : "Delete leave"
                }
              >
                <Trash2 size={18} />
              </button>
            )}
          </div>
        );
      },
    },
  ];

  const otherColumns = [
    {
      title: "Start",
      dataIndex: "startDate",
      key: "startDate",
      width: 120,
      render: (startDate) =>
        startDate ? moment.utc(startDate).format("MM/DD/YYYY") : "-",
    },
    {
      title: "End",
      dataIndex: "endDate",
      key: "endDate",
      width: 120,
      render: (endDate) =>
        endDate ? moment.utc(endDate).format("MM/DD/YYYY") : "-",
    },
    {
      title: "Expected Delivery",
      dataIndex: "expectedDeliveryDate",
      key: "expectedDeliveryDate",
      width: 150,
      render: (expectedDeliveryDate) =>
        expectedDeliveryDate
          ? moment.utc(expectedDeliveryDate).format("MM/DD/YYYY")
          : "-",
    },
          {
      title: "Post",
      dataIndex: "appliedOn",
      key: "appliedOn",
      width: 120,
      render: (appliedOn) =>
        appliedOn ? moment.utc(appliedOn).format("MM/DD/YYYY") : "-",
    },
    {
      title: "Document",
      dataIndex: "document",
      key: "document",
      width: 120,
      render: (documentPath) => {
        if (!documentPath) return "-";
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => {
              let cleanPath = documentPath.replace(/\\/g, '/');
              if (!cleanPath.startsWith('/') && !cleanPath.startsWith('http')) {
                cleanPath = '/' + cleanPath;
              }
              const backendBase = axios.defaults.baseURL.replace('/api', '');
              const fileUrl = cleanPath.startsWith('http')
                ? cleanPath
                : `${backendBase}${cleanPath}`;
              window.open(fileUrl, '_blank');
            }}
          >
            View
          </Button>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      width: 200,
      render: (_, record) => {
        const renderApprovalStatus = (approval) => {
          if (approval === null) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f0ad4e",
                  borderColor: "#f0ad4e",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Pending
              </Button>
            );
          } else if (approval === true) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#52c41a",
                  borderColor: "#52c41a",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Approved
              </Button>
            );
          } else if (approval === false) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f5222d",
                  borderColor: "#f5222d",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Rejected
              </Button>
            );
          } else {
            return (
              <Button type="default" size="small">
                -
              </Button>
            );
          }
        };
        return renderApprovalStatus(record.approval);
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 200,
      render: (reason) => reason || "-",
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) => {
        const adminStatus = record?.approval; // null=Pending, true=Approved, false=Rejected

        // fix.md rules for Short/Duty/Special/Maternity leaves (no coverup):
        // Admin Approved → Edit ❌ | Delete ❌
        // Admin Rejected → Edit ❌ | Delete ❌
        // Admin Pending  → Edit ✅ | Delete ✅
        if (adminStatus !== null) return null;

        return (
          <div className="action-table-data">
            <button
              className={`action-button edit-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "edit",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                ) {
                  setSelectedEmployeeLeave(record);
                  setIsModalOpen(true);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to edit employee leaves"
                  : "Edit leave"
              }
            >
              <Edit size={18} />
            </button>
            <button
              className={`action-button delete-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "delete",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                ) {
                  handleDelete(record._id || record.id);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to delete employee leaves"
                  : "Delete leave"
              }
            >
              <Trash2 size={18} />
            </button>
          </div>
        );
      },
    },
  ];

  const shortLeaveColumns = [
    {
      title: "Type",
      dataIndex: "leave_time",
      key: "leave_time",
      width: 150,
      render: (leave_time) => leave_time || "-",
    },
    {
      title: "Start",
      dataIndex: "startDate",
      key: "startDate",
      width: 120,
      render: (startDate) =>
        startDate ? moment.utc(startDate).format("MM/DD/YYYY") : "-",
    },
    {
      title: "End",
      dataIndex: "endDate",
      key: "endDate",
      width: 120,
      render: (endDate) =>
        endDate ? moment.utc(endDate).format("MM/DD/YYYY") : "-",
    },
        {
      title: "Post",
      dataIndex: "appliedOn",
      key: "appliedOn",
      width: 120,
      render: (appliedOn) =>
        appliedOn ? moment.utc(appliedOn).format("MM/DD/YYYY") : "-",
    },
    {
      title: "Status",
      key: "status",
      width: 200,
      render: (_, record) => {
        const renderApprovalStatus = (approval) => {
          if (approval === null) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f0ad4e",
                  borderColor: "#f0ad4e",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Pending
              </Button>
            );
          } else if (approval === true) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#52c41a",
                  borderColor: "#52c41a",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Approved
              </Button>
            );
          } else if (approval === false) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f5222d",
                  borderColor: "#f5222d",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Rejected
              </Button>
            );
          } else {
            return (
              <Button type="default" size="small">
                -
              </Button>
            );
          }
        };
        return renderApprovalStatus(record.approval);
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 200,
      render: (reason) => reason || "-",
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) =>
        record?.approval !== true && (
          <div className="action-table-data">
            <button
              className={`action-button edit-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "edit",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                ) {
                  setSelectedEmployeeLeave(record);
                  setIsModalOpen(true);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to edit employee leaves"
                  : "Edit leave"
              }
            >
              <Edit size={18} />
            </button>
            <button
              className={`action-button delete-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "delete",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                ) {
                  handleDelete(record._id || record.id);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to delete employee leaves"
                  : "Delete leave"
              }
            >
              <Trash2 size={18} />
            </button>
          </div>
        ),
    },
  ];

  const dutyLeaveColumns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 120,
      render: (date) => (date ? moment.utc(date).format("MM/DD/YYYY") : "-"),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 200,
      render: (reason) => reason || "-",
    },
          {
      title: "Post",
      dataIndex: "appliedOn",
      key: "appliedOn",
      width: 120,
      render: (appliedOn) =>
        appliedOn ? moment.utc(appliedOn).format("MM/DD/YYYY") : "-",
    },
    {
      title: "Status",
      key: "status",
      width: 200,
      render: (_, record) => {
        const renderApprovalStatus = (approval) => {
          if (approval === null) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f0ad4e",
                  borderColor: "#f0ad4e",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Pending
              </Button>
            );
          } else if (approval === true) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#52c41a",
                  borderColor: "#52c41a",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Approved
              </Button>
            );
          } else if (approval === false) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f5222d",
                  borderColor: "#f5222d",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Rejected
              </Button>
            );
          } else {
            return (
              <Button type="default" size="small">
                -
              </Button>
            );
          }
        };
        return renderApprovalStatus(record.approval);
      },
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) =>
        record?.approval !== true && (
          <div className="action-table-data">
            <button
              className={`action-button edit-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "edit",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                ) {
                  setSelectedEmployeeLeave(record);
                  setIsModalOpen(true);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to edit employee leaves"
                  : "Edit leave"
              }
            >
              <Edit size={18} />
            </button>
            <button
              className={`action-button delete-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "delete",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                ) {
                  handleDelete(record._id || record.id);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to delete employee leaves"
                  : "Delete leave"
              }
            >
              <Trash2 size={18} />
            </button>
          </div>
        ),
    },
  ];

  const specialLeaveColumns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 120,
      render: (date) => (date ? moment.utc(date).format("MM/DD/YYYY") : "-"),
    },

          {
      title: "Post",
      dataIndex: "appliedOn",
      key: "appliedOn",
      width: 120,
      render: (appliedOn) =>
        appliedOn ? moment.utc(appliedOn).format("MM/DD/YYYY") : "-",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 200,
      render: (reason) => reason || "-",
    },
    {
      title: "First Approval",
      key: "approval",
      width: 150,
      render: (_, record) => {
        const renderApprovalStatus = (approval) => {
          if (approval === null) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f0ad4e",
                  borderColor: "#f0ad4e",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Pending
              </Button>
            );
          } else if (approval === true) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#52c41a",
                  borderColor: "#52c41a",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Approved
              </Button>
            );
          } else if (approval === false) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f5222d",
                  borderColor: "#f5222d",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Rejected
              </Button>
            );
          } else {
            return (
              <Button type="default" size="small">
                -
              </Button>
            );
          }
        };
        return renderApprovalStatus(record.approval);
      },
    },
    {
      title: "Second Approval",
      key: "secondLevelApproval",
      width: 150,
      render: (_, record) => {
        const renderApprovalStatus = (approval) => {
          if (approval === null) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f0ad4e",
                  borderColor: "#f0ad4e",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Pending
              </Button>
            );
          } else if (approval === true) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#52c41a",
                  borderColor: "#52c41a",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Approved
              </Button>
            );
          } else if (approval === false) {
            return (
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: "#f5222d",
                  borderColor: "#f5222d",
                  color: "#fff",
                  width: "90%",
                }}
              >
                Rejected
              </Button>
            );
          } else {
            return (
              <Button type="default" size="small">
                -
              </Button>
            );
          }
        };
        return renderApprovalStatus(record.secondLevelApproval);
      },
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) =>
        record?.approval !== true && (
          <div className="action-table-data">
            <button
              className={`action-button edit-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "edit",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                ) {
                  setSelectedEmployeeLeave(record);
                  setIsModalOpen(true);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "edit",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to edit employee leaves"
                  : "Edit leave"
              }
            >
              <Edit size={18} />
            </button>
            <button
              className={`action-button delete-button ${
                user?.permissions &&
                hasPermission(
                  user.permissions,
                  "HRM",
                  "Leaves",
                  "delete",
                  "Employee Leaves"
                )
                  ? ""
                  : "disabled-button"
              }`}
              onClick={() => {
                if (
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                ) {
                  handleDelete(record._id || record.id);
                }
              }}
              title={
                !(
                  user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "delete",
                    "Employee Leaves"
                  )
                )
                  ? "You don't have permission to delete employee leaves"
                  : "Delete leave"
              }
            >
              <Trash2 size={18} />
            </button>
          </div>
        ),
    },
  ];

  const coverupRequestColumns = [
    {
      title: "Employee",
      dataIndex: ["employee", "full_name"],
      key: "employee",
      width: 200,
      render: (_, record) => (
        <span>
          {record.employee?.full_name ||
            `${record.employee?.first_name} ${record.employee?.last_name}`}
          <br />
          <small>ID: {record.employee?.employee_id}</small>
        </span>
      ),
    },
    {
      title: "Leave Type",
      dataIndex: ["leavetype", "name"],
      key: "leavetype",
      width: 150,
    },
    {
      title: "Start",
      dataIndex: "startDate",
      key: "startDate",
      width: 120,
      render: (startDate) =>
        startDate ? moment.utc(startDate).format("MM/DD/YYYY") : "-",
    },
    {
      title: "End",
      dataIndex: "endDate",
      key: "endDate",
      width: 120,
      render: (endDate) =>
        endDate ? moment.utc(endDate).format("MM/DD/YYYY") : "-",
    },
    {
      title: "Status",
      dataIndex: "coverupStatus",
      key: "status",
      width: 200,
      render: (status) => {
        const statusMap = {
          PENDING: { color: "#f0ad4e", text: "Pending" },
          ACCEPTED: { color: "#52c41a", text: "Accepted" },
          REJECTED: { color: "#f5222d", text: "Rejected" },
        };
        return (
          <Button
            type="primary"
            size="small"
            style={{
              backgroundColor: statusMap[status]?.color || "#d9d9d9",
              borderColor: statusMap[status]?.color || "#d9d9d9",
              color: "#fff",
              width: "90%",
            }}
          >
            {statusMap[status]?.text || status}
          </Button>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: 200,
      render: (_, record) =>
        record.coverupStatus === "PENDING" && (
          <div className="action-table-data">
            <Button
              type="primary"
              size="small"
              onClick={() => handleCoverupResponse(record._id, "ACCEPTED")}
              style={{ marginRight: "8px" }}
            >
              Accept
            </Button>
            <Button
              danger
              size="small"
              onClick={() => {
                Swal.fire({
                  title: "Reject Reason",
                  input: "textarea",
                  inputPlaceholder: "Enter reason for rejection...",
                  showCancelButton: true,
                  confirmButtonText: "Submit",
                  preConfirm: (reason) => {
                    if (!reason) {
                      Swal.showValidationMessage("Reason is required");
                    }
                    return reason;
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleCoverupResponse(record._id, "REJECTED", result.value);
                  }
                });
              }}
            >
              Reject
            </Button>
          </div>
        ),
    },
  ];

  const mySentCoverupColumns = [
    {
      title: "Coverup Employee",
      dataIndex: ["coverupEmployee", "full_name"],
      key: "coverupEmployee",
      width: 200,
      render: (_, record) => (
        <span>
          {record.coverupEmployee?.full_name ||
            `${record.coverupEmployee?.first_name || ""} ${record.coverupEmployee?.last_name || ""}`}
        </span>
      ),
    },
    {
      title: "Leave Type",
      dataIndex: ["leavetype", "name"],
      key: "leavetype",
      width: 150,
    },
    {
      title: "Start",
      dataIndex: "startDate",
      key: "startDate",
      width: 120,
      render: (startDate) =>
        startDate ? moment.utc(startDate).format("MM/DD/YYYY") : "-",
    },
    {
      title: "End",
      dataIndex: "endDate",
      key: "endDate",
      width: 120,
      render: (endDate) =>
        endDate ? moment.utc(endDate).format("MM/DD/YYYY") : "-",
    },
    {
      title: "Status",
      dataIndex: "coverupStatus",
      key: "status",
      width: 150,
      render: (status) => {
        const statusMap = {
          PENDING: { color: "#f0ad4e", text: "Pending" },
          ACCEPTED: { color: "#52c41a", text: "Accepted" },
          REJECTED: { color: "#f5222d", text: "Rejected" },
        };
        return (
          <Button
            type="primary"
            size="small"
            style={{
              backgroundColor: statusMap[status]?.color || "#d9d9d9",
              borderColor: statusMap[status]?.color || "#d9d9d9",
              color: "#fff",
              width: "90%",
            }}
          >
            {statusMap[status]?.text || status}
          </Button>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: 200,
      render: (_, record) =>
        record.coverupStatus === "PENDING" && (
          <div className="action-table-data">
            <Button
              type="primary"
              size="small"
              onClick={() => handleCoverupResponse(record._id, "ACCEPTED")}
              style={{ marginRight: "8px" }}
            >
              Approve
            </Button>
            <Button
              danger
              size="small"
              onClick={() => {
                Swal.fire({
                  title: "Reject Reason",
                  input: "textarea",
                  inputPlaceholder: "Enter reason for rejection...",
                  showCancelButton: true,
                  confirmButtonText: "Submit",
                  preConfirm: (reason) => {
                    if (!reason) {
                      Swal.showValidationMessage("Reason is required");
                    }
                    return reason;
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleCoverupResponse(record._id, "REJECTED", result.value);
                  }
                });
              }}
            >
              Reject
            </Button>
          </div>
        ),
    },
  ];

  return (
    <div className="wrapper-leave">
      {contextHolder}
      <div className="content-leave">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Employee Leaves</h4>
                <h6>Manage your Leaves</h6>
              </div>
            </div>
            <div className="page-btn" style={{ display: "none" }}>
              <button
                className="btn btn-added"
                onClick={() => setIsAddModalOpen(true)}
                disabled={
                  !(
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "HRM",
                      "Leaves",
                      "create",
                      "Employee Leaves"
                    )
                  )
                }
              >
                Apply Leave
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="leave-management-container">
        <div className="leave-management-left">
          <div className="leave-stats">
            <div className="leave-stat-item">
              <div className="leave-stat-icon">
                <Calendar size={24} />
              </div>
              <div className="leave-stat-content">
                <div className="leave-stat-value working-days">
                  {workingDays !== null ? workingDays : "Loading..."}
                </div>
                <div className="leave-stat-label">Working Days</div>
                <div className="leave-stat-sublabel">Total for this month</div>
              </div>
            </div>
            {leaveBalances.map((balance, index) => (
              <div className="leave-stat-item" key={index}>
                <div className="leave-stat-icon">
                  <div className="leave-stat-sublabel">Available</div>
                </div>
                <div className="leave-stat-content">
                  <div className="leave-stat-value leave-days">
                    <span className="current-balance">
                      {balance.currentBalance}
                    </span>
                    <span className="total-leaves" style={{ display: "none" }}>
                      {balance.leaveType.totalLeaves}
                    </span>
                  </div>
                  <div className="leave-stat-label">
                    {balance.leaveType.name}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="card table-list-card-leave">
            <div
              className="table-top-filter"
              style={{
                padding: "16px 16px 0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <DatePicker
                placeholder="Filter by Date"
                onChange={(date) => setSelectedDate(date)}
                style={{ width: 200 }}
                value={selectedDate}
              />
            </div>
            <div className="button-container">
              <button
                className={`table-tag-leave ${
                  activeTab === "leaves" ? "active" : ""
                }`}
                onClick={() => setActiveTab("leaves")}
              >
                Regular
              </button>
              <button
                className={`table-tag-leave ${
                  activeTab === "shortLeaves" ? "active" : ""
                }`}
                onClick={() => setActiveTab("shortLeaves")}
              >
                Short
              </button>
              <button
                className={`table-tag-leave ${
                  activeTab === "dutyLeaves" ? "active" : ""
                }`}
                onClick={() => setActiveTab("dutyLeaves")}
              >
                Duty
              </button>
              <button
                className={`table-tag-leave ${
                  activeTab === "specialLeaves" ? "active" : ""
                }`}
                onClick={() => setActiveTab("specialLeaves")}
              >
                Special
              </button>
              <button
                className={`table-tag-leave ${
                  activeTab === "maternityLeaves" ? "active" : ""
                }`}
                onClick={() => setActiveTab("maternityLeaves")}
              >
                Maternity
              </button>
              <button
                className={`table-tag-leave ${
                  activeTab === "coverupRequests" ? "active" : ""
                }`}
                onClick={() => setActiveTab("coverupRequests")}
              >
                Coverup Requests
              </button>
              <button
                className={`table-tag-leave ${
                  activeTab === "mySentCoverup" ? "active" : ""
                }`}
                onClick={() => setActiveTab("mySentCoverup")}
              >
                Sent Coverup
              </button>
            </div>
            <div className="card-body-leave">
              {activeTab === "leaves" && (
                <div style={{ overflowX: "auto" }}>
                  <Table
                    columns={regularColumns}
                    dataSource={filteredData}
                    rowKey={(record) => record.key || record._id}
                    pagination={{
                      current: pagination.current,
                      pageSize: pagination.pageSize,
                      total: filteredData.length,
                      showSizeChanger: true,
                      pageSizeOptions: [5, 10, 20, 50, 100],
                      showTotal: (total) => `Total ${total} items`,
                    }}
                    onChange={handleTableChange}
                    rowClassName={(record) =>
                      record?.approval === true
                        ? "approved-row"
                        : record?.approval === false
                        ? "rejected-row"
                        : "pending-row"
                    }
                    scroll={{ x: 900 }}
                    loading={loading}
                  />
                </div>
              )}
              {activeTab === "shortLeaves" && (
                <Table
                  columns={shortLeaveColumns}
                  dataSource={processLeaves(shortLeaves)}
                  rowKey={(record) => record._id || record.id}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: shortLeaves.length,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                  rowClassName={(record) =>
                    record?.approval === true
                      ? "approved-row"
                      : record?.approval === false
                      ? "rejected-row"
                      : "pending-row"
                  }
                  loading={loading}
                />
              )}
              {activeTab === "dutyLeaves" && (
                <Table
                  columns={dutyLeaveColumns}
                  dataSource={processLeaves(dutyLeaves)}
                  rowKey={(record) => record._id || record.id}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: dutyLeaves.length,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                  rowClassName={(record) =>
                    record?.approval === true
                      ? "approved-row"
                      : record?.approval === false
                      ? "rejected-row"
                      : "pending-row"
                  }
                  loading={loading}
                />
              )}
              {activeTab === "specialLeaves" && (
                <Table
                  columns={specialLeaveColumns}
                  dataSource={processLeaves(specialLeaves)}
                  rowKey={(record) => record._id || record.id}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: specialLeaves.length,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                  rowClassName={(record) =>
                    record?.approval === true
                      ? "approved-row"
                      : record?.approval === false
                      ? "rejected-row"
                      : "pending-row"
                  }
                  loading={loading}
                />
              )}
              {activeTab === "maternityLeaves" && (
                <Table
                  columns={otherColumns}
                  dataSource={processLeaves(maternityLeaves)}
                  rowKey={(record) => record._id || record.id}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: maternityLeaves.length,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                  rowClassName={(record) =>
                    record?.approval === true
                      ? "approved-row"
                      : record?.approval === false
                      ? "rejected-row"
                      : "pending-row"
                  }
                  loading={loading}
                />
              )}
              {activeTab === "coverupRequests" && (
                <Table
                  columns={coverupRequestColumns}
                  dataSource={processLeaves(coverupRequests)}
                  rowKey={(record) => record._id}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: coverupRequests.length,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                  rowClassName={(record) =>
                    record.coverupStatus === "ACCEPTED"
                      ? "approved-row"
                      : record.coverupStatus === "REJECTED"
                      ? "rejected-row"
                      : "pending-row"
                  }
                  loading={loading}
                />
              )}
              {activeTab === "mySentCoverup" && (
                <Table
                  columns={mySentCoverupColumns}
                  dataSource={processLeaves(mySentCoverupRequests)}
                  rowKey={(record) => record._id}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: mySentCoverupRequests.length,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                  rowClassName={(record) =>
                    record.coverupStatus === "ACCEPTED"
                      ? "approved-row"
                      : record.coverupStatus === "REJECTED"
                      ? "rejected-row"
                      : "pending-row"
                  }
                  loading={loading}
                />
              )}
            </div>
          </div>
        </div>

        <div className="leave-management-right">
          <AddLeaveEmployee
            handleCancel={handleAddModalCancel}
            leaveBalances={leaveBalances}
            FetchLeaveEmployees={handleReload}
            visible={isAddModalOpen}
            isFemale={isFemale}
          />
        </div>
      </div>

      <Modal
        zIndex={10000}
        open={isAddModalOpen}
        onOk={handleAddModalOk}
        onCancel={handleAddModalCancel}
        footer={null}
      />
      <Modal
        zIndex={10000}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        {selectedEmployeeLeave && (
          <EditLeaveEmployee
            selectedEmployeeLeave={selectedEmployeeLeave}
            handleCancel={handleCancel}
          />
        )}
      </Modal>
    </div>
  );
};

export default LeavesEmployee;
